import * as React from "react";
const SvgFiRrCoconut = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-coconut_svg__a)">
      <path
        fill="#062147"
        d="M6.686 17c.404 0 .845-.05 1.311-.151 1.867-.412 3.9-1.61 5.575-3.283 1.52-1.52 2.635-3.311 3.14-5.045.49-1.684.35-3.122-.376-3.846-.648-.648-1.878-.834-3.32-.52-1.868.413-3.9 1.609-5.575 3.284-1.52 1.519-2.635 3.31-3.14 5.045-.49 1.684-.35 3.12.374 3.845.444.443 1.145.672 2.011.672m2.168-8.147c1.413-1.412 3.086-2.412 4.591-2.744.317-.07.624-.106.888-.106.381 0 .55.065.572.067.31.468.06 3.278-2.747 6.082-1.413 1.412-3.087 2.413-4.59 2.745-.954.208-1.42.057-1.462.039-.31-.468-.059-3.28 2.748-6.083M20.38 2.906s-1.478-1.44-1.596-1.488C15.415-1.352 9.365 0 4.682 4.683.018 9.347-1.343 15.368 1.38 18.743c.05.122 1.523 1.638 1.523 1.638a12.31 12.31 0 0 0 8.738 3.614c3.165 0 6.33-1.205 8.738-3.614A12.27 12.27 0 0 0 24 11.643c0-3.3-1.285-6.404-3.62-8.738zM6.096 6.098c2.62-2.62 5.853-4.085 8.432-4.085 1.317 0 2.465.383 3.272 1.19 2.387 2.388 1.061 7.747-2.896 11.704C10.947 18.863 5.59 20.19 3.2 17.802.813 15.414 2.14 10.055 6.096 6.098m12.87 12.87c-3.184 3.185-7.937 3.847-11.787 2.01 2.95-.212 6.295-1.813 9.14-4.657s4.451-6.187 4.666-9.133A10.3 10.3 0 0 1 22 11.644c0 2.767-1.077 5.368-3.034 7.324"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-coconut_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCoconut;
